import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class FarmHasUnitsModel extends BaseModel {

    constructor() {
        super({
                name: "farm_has_unit",
                tableName: 'farm_has_unit',
                label: "Unit trong trang trai",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                unit_id: { 
                    name: 'unit_id',
                    display: false
                },
                farm_id: { 
                    name: 'farm_id',
                    display: false
                }

            },
            )
    }

}